import { render } from "./BaseOverlay.vue?vue&type=template&id=e87c780c"
import script from "./BaseOverlay.vue?vue&type=script&lang=js"
export * from "./BaseOverlay.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__